// extracted by mini-css-extract-plugin
export default {"projectsContainer":"Projects_projectsContainer__xbR3t","title":"Projects_title__tBYLF","line":"Projects_line__NnHdi","revProjects":"Projects_revProjects__p9Fjj"};